import { useTranslation } from 'react-i18next'

import {
  InstantChip,
  NoInstantChip,
  ReturnProtectionChip,
  SummaryAmount,
  TransactionTypeChip,
} from '@reveni-io/reveni-ui'
import { Divider } from '@reveni-io/reveni-ui'

import CustomerRating from '@/common/components/CustomerRating/CustomerRating'
import UpdatedTimeText from '@/common/components/UpdatedTimeText/UpdatedTimeText'
import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'
import InformationAboutPaymentAndRefund from '@/returns/components/InformationAboutPaymentAndRefund/InformationAboutPaymentAndRefund'
import OrderItemDate from '@/returns/components/OrderItemDate/OrderItemDate'
import SelectBadgeStatus from '@/returns/components/SelectBadgeStatus/SelectBadgeStatus'
import { statuses, transactionTypes } from '@/returns/constants'

import ExchangeForOrder from './ExchangeForOrder/ExchangeForOrder'
import TransactionTags from './TransactionTags/TransactionTags'
import * as Styles from './styles'

const TransactionDetails = ({
  availableStatus,
  onChangeStatus,
  status,
  transactionType,
  isInstant,
  isCoveredByReturnProtection,
  completedAt,
  modified,
  exchangedForOrder,
  exchangeForOrderNumber,
  exchangedForOrderExternalUrl,
  amount,
  currency,
  paymentStatus,
  paymentAmount,
  refundStatus,
  refundAmount,
  refundMethod,
  summaryStatus,
  pendingAmount,
  adjustments,
  onIssueRefund,
  onCancelStoreCredit,
  onCancelGiftCard,
  disabledIssueRefund,
  onPutRefundOnHold,
  allowPutRefundOnHold,
  issueExchangeAtStatus,
  remainingAmount,
  onMarkAsIssued,
  allowMarkAsIssued,
  allowCancelStoreCredit,
  allowCancelGiftCard,
  storeId,
  customerReviewRating,
  onMarkAsPaid,
  allowMarkAsPaid,
  tags,
  onChangeTags,
}) => {
  const { i18n } = useTranslation()
  const { hasPermission } = useUserPermissions()

  return (
    <Styles.MainContainer>
      <Styles.InfoContainer>
        <SelectBadgeStatus
          statusOptions={hasPermission(userPermissions.editReturnStatus, storeId) ? availableStatus : []}
          selected={status}
          onChange={status => onChangeStatus(status)}
          fullWidth
          height="24px"
        />
        <Styles.TransactionTypeContainer>
          <TransactionTypeChip status={status} type={transactionType} />
          {isInstant ? <InstantChip status={status} /> : <NoInstantChip status={status} />}
          {isCoveredByReturnProtection && <ReturnProtectionChip />}
        </Styles.TransactionTypeContainer>
        <Styles.DatesContainer>
          <OrderItemDate status={status} language={i18n.language} completedAt={completedAt} />
          <UpdatedTimeText modified={modified} status={status} />
        </Styles.DatesContainer>
      </Styles.InfoContainer>
      <CustomerRating rating={customerReviewRating} />
      <Divider />
      {status !== statuses.cancelled && (
        <>
          <SummaryAmount
            currency={currency}
            amount={amount}
            paymentAmount={paymentAmount}
            refundAmount={refundAmount}
            refundStatus={refundStatus}
            adjustments={adjustments}
            refundMethod={refundMethod}
            summaryStatus={summaryStatus}
            pendingAmount={pendingAmount}
            onIssueRefund={onIssueRefund}
            onCancelStoreCredit={onCancelStoreCredit}
            onCancelGiftCard={onCancelGiftCard}
            disabledIssueRefund={disabledIssueRefund}
            onPutRefundOnHold={onPutRefundOnHold}
            allowPutRefundOnHold={allowPutRefundOnHold}
            exchangeForOrderPaymentStatus={exchangedForOrder?.payment_status}
            transactionType={transactionType}
            paymentStatus={paymentStatus}
            onMarkAsIssued={onMarkAsIssued}
            allowMarkAsIssued={allowMarkAsIssued}
            allowCancelStoreCredit={allowCancelStoreCredit}
            allowCancelGiftCard={allowCancelGiftCard}
            onMarkAsPaid={onMarkAsPaid}
            allowMarkAsPaid={allowMarkAsPaid}
          />
          <InformationAboutPaymentAndRefund
            isInstant={isInstant}
            exchangedForOrder={exchangedForOrder}
            issueExchangeAtStatus={issueExchangeAtStatus}
            paymentStatus={paymentStatus}
            refundStatus={refundStatus}
            remainingAmount={remainingAmount}
            summaryTotalAmount={amount}
            transactionStatus={status}
            transactionType={transactionType}
          />
          {exchangeForOrderNumber && transactionType !== transactionTypes.refund && (
            <>
              <Divider />
              <ExchangeForOrder
                exchangeForOrderNumber={exchangeForOrderNumber}
                exchangedForOrderExternalUrl={exchangedForOrderExternalUrl}
              />
            </>
          )}
        </>
      )}

      <TransactionTags tags={tags} onChangeTags={onChangeTags} status={status} />
    </Styles.MainContainer>
  )
}

export default TransactionDetails
